import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { AMENDS_AUDIENCE_INTERNAL } from "../../project/amends/lib/audience-aware-amends.mjs"

export const getAuthoringPdfExportData = api(async function getAuthoringPdfExportData({
    projectId,
    scheduleId,
    audience = AMENDS_AUDIENCE_INTERNAL,
}) {
    if (!projectId || !scheduleId) return null

    return query(
        gql`
            query GetAuthoringPdfExportData($projectId: String!, $scheduleId: String!, $audience: String) {
                getAuthoringPdfExportData(projectId: $projectId, scheduleId: $scheduleId, audience: $audience)
            }
        `,
        { projectId, scheduleId, audience },
        { returns: "getAuthoringPdfExportData", fetchPolicy: "network-only" }
    )
})
